import {
    apiConstants,
    config,
    downloadBlob,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../../Utilities/Api";

//************************************************** STANDARD API SERVER CALLS ****************************************

class serverQueueApi {
    static getItemsReadyForCheckout(loanSearchCriteria: Record<string, unknown>) {
        const queryParameters = new URLSearchParams(loanSearchCriteria as Record<string, string>).toString();
        return sendRequest(
            requestOptions(config.URL + `loan/?${queryParameters}`,
                requestTypes.GET,
            ),
        );
    }
    static getLoanPackingList(queueItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `loan/${queueItemId}/packing-list`,
                requestTypes.GET,
            ),
        );
    }
    static getListsForDropDowns(systemType: string | number) {
        return sendRequest(
            requestOptions(config.URL + `queue/${systemType}/dropdown-lists`,
                requestTypes.GET,
            ),
        );
    }

    static loan(queueId: string, loanStatus: string | number) {
        return sendRequest(
            requestOptions(config.URL + `loan/` + queueId,
                requestTypes.POST,
                null,
                apiConstants.successMessage.loan.PROCESS + `"${loanStatus}".`,
            ),
        );
    }

    static exportLoansReport(userSearchCriteria: Record<string, unknown>, filteredReport: boolean) {
          const params = {
            ...userSearchCriteria,
            filteredReports: filteredReport
        };
        const queryParameters = new URLSearchParams(params as unknown as Record<string, string>).toString();
        return downloadBlob(
            requestOptions(config.URL + `reports/loan-library/export?${queryParameters}`,
                requestTypes.GET,
                null,
                apiConstants.successMessage.report.REPORT_DOWNLOADED,
            ),
        );
    }
}

export const loanApi = config.environment.MODE === config.modes.SERVER ? serverQueueApi : serverQueueApi;
